// extracted by mini-css-extract-plugin
export default {"container":"CandidatesSocialmedia_container__wqRjq","title":"CandidatesSocialmedia_title__EvhZh","subTitle":"CandidatesSocialmedia_subTitle__hpXrt"};